<template>
    <div class="activity-modal input-full-width">
        <div class="modal-header">
            <h2 class="text-center" v-if="data === undefined">Opret aktivitet</h2>
            <h2 class="text-center" v-else>Rediger aktivitet</h2>
        </div>

        <div class="form">
            <div class="grid-x" v-if="(!data || !data.requisitionStatus || data.requisitionStatus === 'Kaldt tilbage')">
                <div class="small-1 cell flexbox-center">
                    <icon class="task-check small-svg" name="task-check" />
                </div>
                <div class="small-3 cell">
                    <label for="select-activity">Aktivitet</label>
                </div>
                <div class="auto cell">
                    <select v-model="selectedActivity">
                        <option value="" disabled>Vælg aktivitet</option>
                        <optgroup v-if="recentActivityTypes.length > 0" label="Senest anvendte">
                            <option v-for="item in recentActivityTypes" :value="item.id" :key="'recent-select-' + item.id">{{ item.label }}</option>
                        </optgroup>
                        <optgroup v-if="recentActivityTypes.length > 0 && otherActivityTypes.length > 0" label="Øvrige">
                            <option v-for="item in otherActivityTypes" :value="item.id" :key="'other-select-' + item.id">{{ item.label }}</option>
                        </optgroup>
                        <option v-else v-for="item in otherActivityTypes" :value="item.id" :key="item.id">{{ item.label }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="grid-x" v-if="(!data || !data.requisitionStatus || data.requisitionStatus === 'Kaldt tilbage')">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="grid-x" v-if="(!data || !data.requisitionStatus || data.requisitionStatus === 'Kaldt tilbage')">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form" v-if="(!data || !data.requisitionStatus || data.requisitionStatus === 'Kaldt tilbage')">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="user small-svg" name="user-reverse-helmet" />
                </div>
                <div class="small-3 cell">
                    <label for="select-user">Entreprenør</label>
                </div>
                <div class="auto cell">
                    <select v-model="firm" :disabled="data && data.requisitionStatus && data.requisitionStatus.toLowerCase() === 'rekvireret'" id="select-user" @change="selectFirm($event)" class="select-options">
                        <option value="" disabled>Vælg virksomhed</option>
                        <option v-for="firm in firms" :selected="selectedFirm" :key="firm.id" :value="firm.id">
                            {{firm.name}}
                        </option>
                    </select>
                </div>
                <div class="small-1 cell text-center flexbox-center"></div>
                <div class="auto cell">
                    <select v-model="user" :disabled="firm && data && data.requisitionStatus && data.requisitionStatus.toLowerCase() === 'rekvireret'" id="select-user" class="select-options" :title="(firm && data && data.requisitionStatus && data.requisitionStatus.toLowerCase() === 'rekvireret') ? '' : 'Vælg en virksomhed først'">
                        <option value="" disabled>Vælg kontaktperson</option>
                        <option v-for="user in users" :selected="selectedUser" :key="user.userId" :value="user.userId">
                            {{user.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="grid-x" v-if="(!data || !data.requisitionStatus || data.requisitionStatus === 'Kaldt tilbage')">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="dollar small-svg" name="dollar" />
                </div>
                <div class="small-3 cell">
                    <label for="reference">Reference</label>
                </div>
                <div class="auto cell">
                    <input type="text" id="reference" v-model="activity.reference" maxlength="50">
                </div>
            </div>
        </div>
        <div class="grid-x">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="link small-svg" name="link" />
                </div>
                <div class="large-3 medium-3 small-3 cell">
                    <label for="hyperlink">Link</label>
                </div>
                <div class="auto cell">
                    <input type="text" id="hyperlink" v-model="activity.hyperlink" maxlength="2000" :onchange="formatHyperlinkOnChange(activity.hyperlink)" @blur="formatHyperlinkOnFocusOut(activity.hyperlink)">
                </div>
                <div class="small-1 cell flexbox-center">
                    <a :href="activity.hyperlink" target="_blank" :title="`Åbn '${activity.hyperlink}' i en ny fane`" :class="{disabled: !activity.hyperlink}">
                        <icon class="link_out small-svg hover" name="link_out" />
                    </a>
                </div>
            </div>
        </div>
        <div class="grid-x">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="bubble small-svg" name="bubble" />
                </div>
                <div class="small-3 cell flexbox-align-items">
                    <label for="textarea">Bemærkning</label>
                </div>
                <div class="auto cell">
                    <textarea v-autogrow="15" class="text-area-form" type="text" rows="4" cols="30" id="textarea" ref="textarea" v-model="activity.description"></textarea>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" v-if="!data" :class="{ disabled: saving || !selectedActivity }" @click="addActivity()">Tilføj</button>
                <button type="button" class="button-green" v-if="data" :class="{ disabled: saving || !selectedActivity }" @click="updateActivity()">Gem</button>
                <button type="button" class="button-naked" @click="closeModal()">Fortryd</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'template-modal-activity',
    props: [
        'data'
    ],
    data () {
        return {
            selectedUser: null,
            selectedFirm: null,
            user: '',
            firm: '',
            activity: {
                activityTypeId: '',
                objectList: []
            },
            activityType: '',
            selectedActivity: null,
            activityFilteredComboBox: [],

            saving: false
        }
    },
    computed: {
        ...mapGetters({
            activities: 'allListsActivity',
            firms: 'getAllFirmsForActivity',
            users: 'getAllUsersInFirmForActivity',
            getActiveTaskId: 'getActiveTaskId',
            selectedSupplyType: 'selectedSupplyType'
        }),
        recentActivityTypes () {
            const recent = this.getRecentActivityTypesFromStorage()
            if (this.activityFilteredComboBox && this.activityFilteredComboBox.length > 0 && recent.length > 0) {
                const totalCount = this.activityFilteredComboBox.length
                const maxRecent = totalCount >= 30 ? 10 : (totalCount >= 15 ? 5 : 0)

                if (maxRecent === 0) return []

                return recent
                    .map(activityTypeId => this.activityFilteredComboBox.find(a => a.id === activityTypeId))
                    .filter(activity => activity !== undefined)
                    .slice(0, maxRecent)
            }
            return []
        },
        otherActivityTypes () {
            if (this.activityFilteredComboBox && this.activityFilteredComboBox.length > 0) {
                if (this.activityFilteredComboBox.length < 15) {
                    return this.activityFilteredComboBox
                }
                if (this.recentActivityTypes.length > 0) {
                    const recentIds = this.recentActivityTypes.map(a => a.id)
                    return this.activityFilteredComboBox.filter(activity => !recentIds.includes(activity.id))
                }
            }
            return this.activityFilteredComboBox
        }
    },
    methods: {
        ...mapActions({
            saveActivityTemplate: 'createUpdateActivityTemplate',
            updateActivityData: 'updateActivity',
            updateActivityTemplateData: 'updateActivityTemplate',
            getOrganizationList: 'getAssociatedOrganizationList',
            getUserList: 'getAssociatedOrganizationUserList',
            createNewActivity: 'createNewActivity'
        }),
        getRecentActivityTypesFromStorage () {
            try {
                const stored = localStorage.getItem(`recent${String(this.selectedSupplyType.systemName).charAt(0).toUpperCase() + String(this.selectedSupplyType.systemName).slice(1)}ActivityTypes`)
                return stored ? JSON.parse(stored) : []
            } catch (e) {
                console.error('Error loading recent activity types from localStorage:', e)
                return []
            }
        },
        saveRecentActivityTypeToStorage (activityTypeId) {
            if (!activityTypeId) return

            try {
                let recent = this.getRecentActivityTypesFromStorage()

                // Remove if already exists
                recent = recent.filter(id => id !== activityTypeId)

                // Add to beginning
                recent.unshift(activityTypeId)

                // Keep only the 10 most recent
                recent = recent.slice(0, 10)

                localStorage.setItem(`recent${String(this.selectedSupplyType.systemName).charAt(0).toUpperCase() + String(this.selectedSupplyType.systemName).slice(1)}ActivityTypes`, JSON.stringify(recent))
            } catch (e) {
                console.error('Error saving recent activity type to localStorage:', e)
            }
        },
        selectFirm ($event) {
            new Promise((resolve, reject) => {
                resolve(this.getUserList({firmaId: this.firms[$event.target.selectedIndex - 1].id, supplyType: [this.selectedSupplyType], initialOrganization: true}))
            }).then(() => {
                if (this.users.length > 0) {
                    this.user = this.users[0].userId
                }
            })
        },
        closeModal () {
            this.$emit('close')
        },
        addActivity () {
            this.saving = true
            for (let i in this.firms) {
                if (this.firms[i].id === this.firm) {
                    this.activity.sentToOrganization = this.firms[i].name
                }
            }
            for (let i in this.users) {
                if (this.users[i].userId === this.user) {
                    this.activity.sentToUser = this.users[i].name
                }
            }
            this.activity.sentToOrganizationId = this.firm
            this.activity.sentToUserId = this.user
            this.activity.activityTypeId = this.selectedActivity
            this.activity.activityType = this.activities.filter(activity => activity.cActivityTypeId === this.selectedActivity)[0].description
            this.activity.selected = false

            if (this.getActiveTaskId) {
                this.activity.taskId = this.getActiveTaskId
            }

            this.saveActivityTemplate(this.activity)
                .then(() => {
                    this.saveRecentActivityTypeToStorage(this.selectedActivity)
                    this.closeModal()
                    this.saving = false
                })
        },
        updateActivity () {
            this.saving = true
            let updateObj = {
                sentToOrganization: this.data.sentToOrganization,
                sentToOrganizationId: this.firm,
                sentToUserId: this.user,
                sentToUser: this.data.sentToUser,
                activityId: this.activity.activityId,
                taskId: this.data.taskId,
                activityTypeId: this.selectedActivity,
                generatedActivityId: this.data.generatedActivityId,
                activityType: this.activities.filter(activity => activity.cActivityTypeId === this.selectedActivity)[0].description,
                description: this.activity.description,
                hyperlink: this.activity.hyperlink,
                reference: this.activity.reference,
                activityVersionStamp: this.activity.activityVersionStamp
            }
            for (let i in this.firms) {
                if (this.firms[i].id === this.firm) {
                    updateObj.sentToOrganization = this.firms[i].name
                }
            }
            for (let i in this.users) {
                if (this.users[i].userId === this.user) {
                    updateObj.sentToUser = this.users[i].name
                }
            }
            this.updateActivityTemplateData(updateObj)
                .then(() => {
                    this.closeModal()
                    this.saving = false
                })
        },
        formatHyperlinkOnChange () {
            if (this.activity.hyperlink != null) {
                if (this.activity.hyperlink.length === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('h') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('ht') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('htt') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('http') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('http:') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('http:/') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('http://') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('https') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('https:') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('https:/') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('https://') === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('http://') === -1 && this.activity.hyperlink.indexOf('https://') === -1) {
                    this.activity.hyperlink = 'https://' + this.activity.hyperlink
                }
            }
        },
        formatHyperlinkOnFocusOut () {
            if (this.activity.hyperlink != null) {
                if (this.activity.hyperlink.length === 0) {
                    return
                }
                if (this.activity.hyperlink.indexOf('http://') === -1 && this.activity.hyperlink.indexOf('https://') === -1) {
                    this.activity.hyperlink = 'https://' + this.activity.hyperlink
                }
            }
        }
    },
    created () {
        if (this.activities && this.activities.length > 0) {
            for (let i in this.activities) {
                let formattedTagList = ''

                if (this.activities[i].tagList) {
                    this.activities[i].tagList.filter(t => t.tagName === 'inspection').forEach((tag) => {
                        formattedTagList += '<span class="ivu-select-item-tag ' + tag.tagName + '">' + tag.description + '</span>'
                    })
                }

                this.activityFilteredComboBox[i] = {id: this.activities[i].cActivityTypeId, value: this.activities[i].description, label: this.activities[i].description, tags: formattedTagList}
            }
        }
        new Promise((resolve, reject) => {
            resolve(this.getOrganizationList({supplyType: this.selectedSupplyType}))
        }).then(() => {
            if (this.data !== undefined) {
                this.activity = JSON.parse(JSON.stringify(this.data))
                this.activityType = this.data.activityType
                if (this.activities && this.activities.length > 0) {
                    if (this.data.activityTypeId) {
                        this.selectedActivity = this.data.activityTypeId
                    }
                }

                this.firm = this.data.sentToOrganizationId
                for (let i in this.firms) {
                    if (this.firms[i].id === this.data.sentToOrganizationId) {
                        this.getUserList({firmaId: this.firms[i].id, supplyType: [this.selectedSupplyType], initialOrganization: true}).then((response) => {
                            this.user = this.data.sentToUserId
                        })
                    }
                }
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/taskTemplate/template-modal-activity.vue